import React from 'react';

const DownloadsDecoration = () => (
  <svg
    width="462"
    height="405"
    viewBox="0 0 462 405"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_1324_18438)">
      <rect
        x="126.738"
        y="233.394"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 126.738 233.394)"
        stroke="#CF8CC0"
      />
      <rect
        x="172.929"
        y="233.394"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 172.929 233.394)"
        stroke="#CF8CC0"
      />
      <rect
        x="219.121"
        y="233.394"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 219.121 233.394)"
        stroke="#CF8CC0"
      />
      <rect
        x="265.312"
        y="233.394"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 265.312 233.394)"
        stroke="#CF8CC0"
      />
      <rect
        x="311.503"
        y="233.394"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 311.503 233.394)"
        stroke="#CF8CC0"
      />
      <rect
        x="126.738"
        y="182.071"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 126.738 182.071)"
        stroke="#CF8CC0"
      />
      <rect
        x="172.929"
        y="182.071"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 172.929 182.071)"
        stroke="#CF8CC0"
      />
      <rect
        x="219.121"
        y="182.071"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 219.121 182.071)"
        stroke="#CF8CC0"
      />
      <rect
        x="265.312"
        y="182.071"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 265.312 182.071)"
        stroke="#CF8CC0"
      />
      <rect
        x="311.503"
        y="182.071"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 311.503 182.071)"
        stroke="#CF8CC0"
      />
      <rect
        x="126.738"
        y="130.746"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 126.738 130.746)"
        stroke="#CF8CC0"
      />
      <rect
        x="172.929"
        y="130.746"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 172.929 130.746)"
        stroke="#CF8CC0"
      />
      <rect
        x="219.121"
        y="130.746"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 219.121 130.746)"
        stroke="#CF8CC0"
      />
      <rect
        x="265.312"
        y="130.746"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 265.312 130.746)"
        stroke="#CF8CC0"
      />
      <rect
        x="311.503"
        y="130.746"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 311.503 130.746)"
        stroke="#CF8CC0"
      />
      <rect
        x="126.738"
        y="79.4238"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 126.738 79.4238)"
        stroke="#CF8CC0"
      />
      <rect
        x="172.929"
        y="79.4238"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 172.929 79.4238)"
        stroke="#CF8CC0"
      />
      <rect
        x="219.121"
        y="79.4238"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 219.121 79.4238)"
        stroke="#CF8CC0"
      />
      <rect
        x="265.312"
        y="79.4238"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 265.312 79.4238)"
        stroke="#CF8CC0"
      />
      <rect
        x="311.503"
        y="79.4238"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 311.503 79.4238)"
        stroke="#CF8CC0"
      />
      <rect
        x="126.738"
        y="28.0991"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 126.738 28.0991)"
        stroke="#CF8CC0"
      />
      <rect
        x="172.929"
        y="28.0991"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 172.929 28.0991)"
        stroke="#CF8CC0"
      />
      <rect
        x="219.121"
        y="28.0991"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 219.121 28.0991)"
        stroke="#CF8CC0"
      />
      <rect
        x="265.312"
        y="28.0991"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 265.312 28.0991)"
        stroke="#CF8CC0"
      />
      <rect
        x="311.503"
        y="28.0991"
        width="25.5993"
        height="25.5993"
        transform="rotate(-90 311.503 28.0991)"
        stroke="#CF8CC0"
      />
    </g>
    <rect
      x="273.277"
      y="266.317"
      width="16.8779"
      height="16.8779"
      transform="rotate(90 273.277 266.317)"
      fill="#411B38"
    />
    <rect
      x="323.833"
      y="406.372"
      width="16.8779"
      height="16.8779"
      transform="rotate(-90 323.833 406.372)"
      fill="#411B38"
    />
    <rect
      x="397.551"
      y="411.283"
      width="16.8779"
      height="16.8779"
      transform="rotate(-90 397.551 411.283)"
      fill="#411B38"
    />
    <rect
      x="130.285"
      y="322.772"
      width="16.8779"
      height="16.8779"
      transform="rotate(90 130.285 322.772)"
      fill="#411B38"
    />
    <rect
      x="289.559"
      y="380.011"
      width="16.8779"
      height="16.8779"
      transform="rotate(90 289.559 380.011)"
      fill="#411B38"
    />
    <rect
      x="243.966"
      y="324.935"
      width="16.8779"
      height="16.8779"
      transform="rotate(90 243.966 324.935)"
      fill="#411B38"
    />
    <rect
      x="167.437"
      y="371.869"
      width="16.8779"
      height="16.8779"
      transform="rotate(90 167.437 371.869)"
      fill="#411B38"
    />
    <rect
      x="195.117"
      y="327.906"
      width="16.8779"
      height="16.8779"
      transform="rotate(90 195.117 327.906)"
      fill="#411B38"
    />
    <rect
      x="106.208"
      y="411.004"
      width="15.8779"
      height="15.8779"
      transform="rotate(-90 106.208 411.004)"
      stroke="#CF8CC0"
    />
    <rect
      x="72.8479"
      y="387.909"
      width="15.8779"
      height="15.8779"
      transform="rotate(-90 72.8479 387.909)"
      stroke="#CF8CC0"
    />
    <rect
      x="188.509"
      y="360.567"
      width="15.8779"
      height="15.8779"
      transform="rotate(-90 188.509 360.567)"
      stroke="#CF8CC0"
    />
    <rect
      x="209.677"
      y="412.673"
      width="15.8779"
      height="15.8779"
      transform="rotate(-90 209.677 412.673)"
      stroke="#CF8CC0"
    />
    <rect
      x="258.526"
      y="352.424"
      width="15.8779"
      height="15.8779"
      transform="rotate(-90 258.526 352.424)"
      stroke="#CF8CC0"
    />
    <rect
      x="286.208"
      y="412.673"
      width="15.8779"
      height="15.8779"
      transform="rotate(-90 286.208 412.673)"
      stroke="#CF8CC0"
    />
    <rect
      x="159.2"
      y="295.721"
      width="15.8779"
      height="15.8779"
      transform="rotate(-90 159.2 295.721)"
      stroke="#CF8CC0"
    />
    <rect
      x="307.375"
      y="352.424"
      width="15.8779"
      height="15.8779"
      transform="rotate(-90 307.375 352.424)"
      stroke="#CF8CC0"
    />
    <rect
      x="201.537"
      y="282.695"
      width="15.8779"
      height="15.8779"
      transform="rotate(-90 201.537 282.695)"
      stroke="#CF8CC0"
    />
    <rect
      x="283.275"
      y="326.321"
      width="15.8779"
      height="15.8779"
      transform="rotate(-90 283.275 326.321)"
      stroke="#CF8CC0"
    />
    <rect
      x="147.748"
      y="346.368"
      width="15.8779"
      height="15.8779"
      transform="rotate(90 147.748 346.368)"
      stroke="#CF8CC0"
    />
    <rect
      x="217.82"
      y="328.288"
      width="15.8779"
      height="15.8779"
      transform="rotate(-90 217.82 328.288)"
      stroke="#CF8CC0"
    />
    <rect
      x="371.006"
      y="372.03"
      width="15.8779"
      height="15.8779"
      transform="rotate(90 371.006 372.03)"
      stroke="#CF8CC0"
    />
    <defs>
      <filter
        id="filter0_d_1324_18438"
        x="122.238"
        y="0"
        width="219.365"
        height="239.894"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1324_18438"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1324_18438"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default DownloadsDecoration;
